export const isElementInViewport = (ele: any, ratio = 0.8) => {
  if (!ele) {
    return false;
  }
  const rect = ele.getBoundingClientRect();
  const { consult_menu } = window.FMC_HOST.consult;
  // 顶部fixed医院信息高度
  const topFixedHeight = 84;
  // 底部fixed高度：除发送框50px外，还有自助咨询菜单的高度
  const bottomFixedHeight = consult_menu && consult_menu.length > 0 ? 90 : 50;
  const vHeight = window.innerHeight || document.documentElement.clientHeight;
  if (rect.top >= topFixedHeight) {
    // 在页面中间 or 卡片底部被遮盖不超过20%
    if (
      rect.bottom <= vHeight - bottomFixedHeight
      || rect.bottom - vHeight + bottomFixedHeight <= rect.height * (1 - ratio)
    ) {
      return true;
    }
    return false;
  }
  // 顶部被遮盖，不超过20%
  if (rect.bottom >= rect.height * ratio + topFixedHeight) {
    return true;
  }
  return false;
};
